import axios from '@utils/axios';
import i18n from '@utils/localization';

const viewRole = {
  state: {
    roleId: 0,
    roleName: '',
    rolePermissions: []
  },
  mutations: {
    setRoleId(state, id) {
      state.roleId = id;
    },
    setRolePermissions(state, permissions) {
      state.rolePermissions = permissions;
    },
    setRoleName(state, name) {
      state.roleName = name;
    }
  },
  actions: {
    fetchRole(context) {
      axios.get('admin/roles/role', {
        params: {
          Id: context.state.roleId,
          locale: i18n.locale
        }
      }).then((res) => {
        context.commit('setRolePermissions', res.data.permissions);
        context.commit('setRoleName', res.data.name);
      });
    },
    resetContext(context) {
      context.commit('setRoleId', 0);
      context.commit('setRolePermissions', []);
      context.commit('setRoleName', '');
    }
  },
  namespaced: true
};

export default viewRole;
